import { NATIVE_ROUTE } from '~~/constants/routes';
import { hasNativeRouteRedirection } from '~~/helpers/navigation/nativeRoutingRedirection';
import { SEO_REDIRECTION_CODE } from '~~/constants/seo';
import { navigateTo, useNuxtApp } from '#imports';
import { Logger } from '~~/helpers/logger';
import type { LocationQueryRaw, LocationQueryValueRaw } from 'vue-router';
import type { CountryCodeValue } from '~~/types/localization/localizationHelperTypes';

type RedirectArgs = {
  oldPrefix: string;
  path: string;
  query: Record<string, unknown>;
  isNativeRoutingEnabled?: boolean;
};

const isLocationQueryValueRaw = (value: unknown): value is LocationQueryValueRaw | LocationQueryValueRaw[] => {

  if (value == null) {

    return true;

  }

  if (Array.isArray(value)) {

    return value.every((entry) => isLocationQueryValueRaw(entry));

  }

  return typeof value === 'string' || typeof value === 'number';

};

const normalizeQuery = (query: Record<string, unknown>): LocationQueryRaw => {

  return Object.entries(query).reduce<LocationQueryRaw>((acc, [key, value]) => {

    if (isLocationQueryValueRaw(value)) {

      acc[key] = value;

    }

    return acc;

  }, {});

};

export const redirectToCorrectPath = ({ oldPrefix, path, query, isNativeRoutingEnabled }: RedirectArgs) => {

  Logger.warn(`Old url structure ${oldPrefix} is still being used.`);
  const replaceValue = isNativeRoutingEnabled ? `/${NATIVE_ROUTE.CATEGORY}/` : '/';
  const newPath = path.replace(oldPrefix, replaceValue);
  const safeQuery = normalizeQuery(query);

  if (newPath === path) {

    return;

  }

  return navigateTo({ path: newPath, query: safeQuery }, { replace: true, redirectCode: SEO_REDIRECTION_CODE });

};

export const getIsNativeRoutingEnabled = () => {

  const nuxtApp = useNuxtApp();
  const i18n = (nuxtApp?.$i18n ?? nuxtApp?.$vueI18n);
  const countryCode = i18n?.localeProperties?.value?.country;
  const normalizedCountryCode = countryCode as CountryCodeValue | undefined;

  return normalizedCountryCode ? hasNativeRouteRedirection(normalizedCountryCode) : false;

};
